import { createContext } from 'react';

import { IndicatorData } from '../../core/components/annotations/components/indicators/types.js';

export const XYChartAnnotationsShownIndicatorsContext = createContext<
  IndicatorData[]
>([]);
